import { Label, Paragraph } from "evergreen-ui";
import React from "react";
import styled from "styled-components";
import Status from "../Status";

const Container = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  cursor: ${(props) => props.cursor};
  :hover {
    opacity: ${(props) => props.hoverOpacity};
  }
`;

const BigContainer = styled.div`
  width: 100%;
  border-bottom: solid 1px ${(props) => props.theme.lightGreyColor};
  :last-child {
    border-bottom: none;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const Footer = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.extraLightGreyColor};
  padding: 1rem;
  padding-top: 0.2rem;
`;
interface IProps {
  date?: any;
  status?: any;
  item?: any;
  figure?: any;
  onClick?: any;
  footer?: any;
}
const RecordRow: React.SFC<IProps> = ({
  date,
  status,
  item,
  figure,
  onClick,
  footer,
}) => {
  return (
    <BigContainer>
      <Container
        onClick={onClick}
        cursor={onClick ? "pointer" : "auto"}
        hoverOpacity={onClick ? "0.7" : "1"}
      >
        <Row>
          <Paragraph size={300}>{date}</Paragraph>
          {status ? <Status status={status} /> : <Label></Label>}
        </Row>
        <Row>
          <Label>{item}</Label>
          <Paragraph fontWeight={700}>{figure}</Paragraph>
        </Row>
      </Container>
      {footer && <Footer>{footer}</Footer>}
    </BigContainer>
  );
};

export default RecordRow;
